import styled from 'styled-components';

import { getColor, getSpace, getTextType, mq } from '../../../../../stylesheets/tools';
import { myFuturiumMap } from '../../../../../helper';

const StyledMarker = styled.div`
  position: absolute;
  top: ${({ coordinates }) => `${coordinates.y * 100}%`};
  left: ${({ coordinates }) => `${coordinates.x * 100}%`};

  .marker__toggle {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${getColor('black')};

    ${mq('m')} {
      width: 16px;
      height: 16px;
    }

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .marker__meta {
    display: ${({ activeMarker, isToggled }) => (activeMarker && !isToggled ? 'block' : 'none')};
    position: absolute;
    margin: 0;
    min-width: 200px;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: ${getColor('black')};
  }

  .marker__link-wrapper {
    position: relative;
    z-index: 1;
    max-width: 165px;
    border: 3px solid ${getColor('black')};
    margin: 6px 0 0 4px;
    padding: ${getSpace('xs')};
    background: ${({ variant, activeMarker }) =>
      activeMarker ? getColor('black') : myFuturiumMap(variant, 'altColor')};

    ${mq('m')} {
      max-width: 310px;
      margin: 4px 0 0 6px;
      padding: ${getSpace('s')};
    }
  }

  .marker__link {
    ${getTextType('tertiary')};
    display: block;
    text-transform: uppercase;
    color: ${({ variant, activeMarker }) =>
      activeMarker ? myFuturiumMap(variant, 'altColor') : getColor('black')};

    svg {
      display: block;
      width: 25px;
      height: 7px;
      margin-top: ${getSpace('xxs')};
      margin-left: auto;

      ${mq('l')} {
        width: 42px;
        height: 12px;
        margin-top: ${getSpace('xs')};
      }
    }
  }

  .marker__treasure-link {
    svg {
      width: 35px;
      height: 33px;

      ${mq('m')} {
        width: 51px;
        height: 48px;
      }
    }
  }

  .marker__arrow {
    position: absolute;
    top: -20px;
    left: 0;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-left: 20px solid
      ${({ variant, activeMarker }) =>
        activeMarker ? getColor('black') : myFuturiumMap(variant, 'altColor')};
    border-bottom: 20px solid transparent;

    &:before {
      content: '';
      position: absolute;
      width: 40px;
      height: 2px;
      background: black;
      transform: rotate(90deg);
      left: -41px;
    }

    &:after {
      content: '';
      position: absolute;
      width: 27px;
      height: 2px;
      background: black;
      transform: rotate(45deg);
      top: -10px;
      left: -24px;
    }
  }
`;

export default StyledMarker;
